export function attachmentUploadState(attachments = []) {
  const uploadingCount = attachments.filter((attachment) =>
    attachmentUploadIsPending(attachment)
  ).length;
  const failedCount = attachments.filter((attachment) =>
    attachmentUploadIsFailed(attachment)
  ).length;

  return {
    uploadingCount,
    failedCount,
    hasBlockingUploads: uploadingCount > 0 || failedCount > 0,
  };
}

function attachmentUploadIsPending(attachment = {}) {
  return Boolean(attachment.uploading) && !attachmentIsPersisted(attachment);
}

function attachmentUploadIsFailed(attachment = {}) {
  return Boolean(attachment.failed) && !attachmentIsPersisted(attachment);
}

function attachmentIsPersisted(attachment = {}) {
  if (!attachment.id) return false;

  const id = String(attachment.id);
  return !id.startsWith("temp-") && !id.startsWith("failed-");
}
